import React from "react";

const BACKEND_URL = 'https://api.talentpedia.digitalnoticeboard.biz/public'
//const BACKEND_URL = 'http://127.0.0.1:8000/public/'

export { BACKEND_URL }